import { fileUpload, verifyLinkedIn } from "api/authService";
import React, { useEffect, useState, useRef } from "react";
import OtpInput from "react-otp-input";
import IMAGES from "constants/images";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";
import { Image, Col, Row, Button, Spinner } from "react-bootstrap";
import CommonModal from "components/CommonModal";
import TextInput from "components/TextInput";
import { verifyReview } from "api/ReviewService";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { createOtp, verifyOtp } from "api/OtpService";
import { useAuth } from "context/UserContext";

const companySchema = yup.object().shape({
  companyName: yup.string().required("Company Name is required"),
  companyEmail: yup
    .string()
    .email("Invalid email")
    .required("Company Email is required"),
});

const StepTwoComponent = ({
  checkedProducts,
  setStep,
  handleNext,
  productId,
  userId,
  setCheckedProducts,
}) => {
  const location=useLocation()
  const [level, setLevel] = useState(1);
  const [vendorInviteLink, setVendorInviteLink] = useState("");
  const [otp, setOtp] = useState("");
  const [modalType, setModalType] = useState("");
  const [fade, setFade] = useState(false);
  const [modalType1, setModalType1] = useState("");
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const { user } = useAuth();
  const [filePreview, setFilePreview] = useState(null);
  const [uploadFile, setUploadedFile] = useState(null);
  const [uploadLoader, setUploadLoader] = useState(false);
  const [resendOtpLoader, setRsendOtpLoader] = useState(false);
  const fileInputRef = useRef();
  const {
    register,
    handleSubmit,
    setError,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(companySchema),
  });

console.log('checkedProducts', checkedProducts)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file.");
      return;
    }
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setFilePreview(previewUrl);
      setUploadedFile(file);
    }

    // Reset input value so the same file can be selected again
    e.target.value = null;
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(countdown);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleShowModal = (type) => {
    setFade(true);
    setTimeout(() => {
      setModalType(type);
      setFade(false);
    }, 300);
  };
  const handleShowModal1 = (type) => {
    setFade(true);
    setTimeout(() => {
      setModalType1(type);
      setFade(false);
    }, 300);
  };
  const handleCloseModal = () => {
    setLevel(1);
    setOtp("");
    setModalType("");
    setFade(false);
    setVendorInviteLink("")
    setUploadedFile(null);
    setFilePreview(null);
    
  };

  const handleCloseModal1 = () => {
    setModalType1("");
    setFade(false);
  };

  const handleLinkedinLogin = async () => {
    if (user?.linkedinId) {
      try {
        const payload = {
          userId: userId,
          productId: productId,
          type: "linkedin",
          data: {
            linkedinId: user?.linkedinId,
          },
        };
        const res = await verifyReview(payload);
        if (res.success === true && res.code === 200) {
          toast.success(res.message);
          if (res.body.status === "verified" && res.body.verificationId) {
            setStep(3);
            localStorage.setItem("verificationId", res.body.verificationId);
            localStorage.setItem("step", 3);
            handleNext();
          }
        } else {
          toast.error(res?.message || "Something went wrong");
        }
      } catch (err) {
        toast.error(err.message || "Something went wrong");
      }
    } else {
      await verifyLinkedIn(location.pathname || "");
    }
  };

  useEffect(() => {
    if (!productId) {
      localStorage.setItem("step", 1);
      localStorage.removeItem("checkedProducts");
      setCheckedProducts([]);
      setStep(1);
    }
    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    const vId = params.get("verificationId");
    if (status === "verified" && vId) {
      setStep(3);
      localStorage.setItem("verificationId", vId);
      localStorage.setItem("step", 3);
    }
  }, [productId]);

  

  const onSubmit = async (data) => {
    try {
      const payload = {
        userId: userId,
        productId: productId,
        type: "company_email",
        data: {
          companyEmail: data.companyEmail,
          companyName: data.companyName,
        },
      };
      const res = await verifyReview(payload);
      handleCloseModal();

      if (res.success === true && res.code === 200) {
        toast.success(res.message);

        if (res.body.status === "verified" && res.body.verificationId) {
          setStep(3);
          localStorage.setItem("verificationId", res.body.verificationId);
          localStorage.setItem("step", 3);
          handleNext();
        }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleOtpVerify = async () => {
    try {
      if (otp.length !== 6) {
        return setError("otp", { message: "Please enter a valid 6-digit OTP" });
      }
      setUploadLoader(true);
      const email = getValues("companyEmail");
      const res = await verifyOtp({
        email,
        otp_code: otp,
        type: "review_verifiation",
      });
      if (res.success === true && res.code === 200) {
        // toast.success(res.message);
        const data = getValues();
        handleCloseModal();
        onSubmit(data);
      } else {
        toast.error(res?.message || "Something went wrong");
      }
      setUploadLoader(false);
    } catch (err) {
      console.log("err", err.message);
      setUploadLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleEmailSubmit = async (data) => {
    setUploadLoader(true);

    const res = await createOtp({
      email: data.companyEmail,
      type: "review_verifiation",
    });
    if (res.success === true && res.code === 200) {
      toast.success(res.message);
      setLevel(2);
      setUploadLoader(false);
    } else {
      setUploadLoader(false);

      toast.error(res.message);
    }
  };

  const handleChange = (code) => setOtp(code);

  const resendOtp = () => {
    setRsendOtpLoader(true);
    const email = getValues("companyEmail");
    handleEmailSubmit({ companyEmail: email }); // Your resend OTP logic
    setTimer(60); // Restart timer
    setCanResend(false); // Disable resend button again
    setRsendOtpLoader(false);
  };

  const handleSubmitImage = async () => {
    try {
      if (!uploadFile) {
        return toast.error("Please upload the screenshot");
      }
      let uploadedImageUrl = null;
      if (uploadFile) {
        setUploadLoader(true);
        const res = await fileUpload(uploadFile);
        if (res.success === true && res.code === 200) {
          uploadedImageUrl = res.body[0];
        } else {
          setUploadLoader(false);
          toast.error(res.message);
        }
      }

      const payload = {
        userId: userId,
        productId: productId,
        type: "screenshot",
        data: {
          screenshotUrl: uploadedImageUrl,
        },
      };
      const res = await verifyReview(payload);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        handleCloseModal();
        if (res.body.status === "verified" && res.body.verificationId) {
          setStep(3);
          localStorage.setItem("verificationId", res.body.verificationId);
          localStorage.setItem("step", 3);
          handleNext();
        }
      } else {
        toast.error(res.message);
      }
      setUploadLoader(false);
    } catch (err) {
      setUploadLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleSubmitVendorLink = async () => {
    try {
      if (vendorInviteLink === "") {
        return toast.error("Please enter invite link");
      }

      setUploadLoader(true);

      const payload = {
        userId: userId,
        productId: productId,
        type: "vendor_invite",
        data: {
          vendorInviteLink: vendorInviteLink,
        },
      };
      const res = await verifyReview(payload);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        handleCloseModal();
        if (res.body.status === "verified" && res.body.verificationId) {
          setStep(3);
          localStorage.setItem("verificationId", res.body.verificationId);
          localStorage.setItem("step", 3);
          handleNext();
        }
      } else {
        toast.error(res.message);
      }
      setUploadLoader(false);
    } catch (err) {
      setUploadLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };
  return (
    <div>
      <h2>4 ways to verify with Xuthority</h2>
      <p className="mb-0">
        At Xuthority, we prioritize authentic reviews from users with
        real-world experience using the software in a professional environment.
      </p>
      <p>
        <strong>Choose one of the following options:</strong>
      </p>
      <Row>
        <Col xs={6} sm={6} lg={6} className="mb-3">
          <div
            className="verify_box cursor-pointer"
            style={{
              backgroundColor: "#F7D4D1",
              cursor: "pointer",
            }}
            onClick={() => {
              reset();
              handleShowModal("moda1");
            }}
          >
            <Image src={IMAGES.VIcon1_Img} alt="verify" />
            <h6>
              Provide your Company
              <br />
              name and email
            </h6>
          </div>
        </Col>
        <Col xs={6} sm={6} lg={6} className="mb-3">
          <div
            onClick={handleLinkedinLogin}
            className="verify_box"
            style={{
              backgroundColor: "#EFE0FE",
              cursor: "pointer",
            }}
          >
            <Image src={IMAGES.VIcon2_Img} alt="verify" />
            <h6>
              Connect your LinkedIn
              <br />
              Profile
            </h6>
          </div>
        </Col>
        <Col xs={6} sm={6} lg={6} className="mb-3">
          <div
            className="verify_box"
            onClick={() => {
              setModalType("moda1");
              setLevel(3);
            }}
            style={{
              backgroundColor: "#CCDAFA",
              cursor: "pointer",
            }}
          >
            <Image src={IMAGES.VIcon3_Img} alt="verify" />
            <h6>
              Continue with unique
              <br />
              vendor invitation link
            </h6>
          </div>
        </Col>
        <Col xs={6} sm={6} lg={6} className="mb-3">
          <div
            onClick={() => setModalType("chooseOption")}
            className="verify_box"
            style={{
              backgroundColor: "#FFF5D4",
              cursor: "pointer",
            }}
          >
            <Image src={IMAGES.VIcon4_Img} alt="verify" />
            <h6>
              Upload a screenshot of
              <br />
              your software
            </h6>
          </div>
        </Col>
      </Row>
      <div className="text-center mt-3">
        <Link className="fw-bold" onClick={() => handleShowModal1("moda1")}>
          I don't want to provide this information{" "}
        </Link>
      </div>
      <CommonModal
        
        className={`modal-fade verifyModal ${fade ? "fade-out" : "fade-in"}`}
        title={
          modalType === "moda1"
            ? "Verify where you work"
            : modalType === "chooseOption"
            ? `Upload screenshot of you using ${checkedProducts[0]?.name || ""}`
            : ""
        }
        para={
          modalType === "moda1"
            ? "Help us quickly verify your review by telling us where you work and confirming your company email."
            : modalType === "chooseOption"
            ? "Upload a screenshot to help the Xuthority moderation team verify your review securely."
            : ""
        }
        body={
          <div className="mt-4">
            {modalType === "moda1" ? (
              <>
                {level === 1 && (
                  <form onSubmit={handleSubmit(handleEmailSubmit)}>
                    <TextInput
                      labelText="Your Company Name"
                      type="text"
                      placeholder="Enter Your Company Name"
                      errorMessage={errors.companyName?.message}
                      {...register("companyName")}
                    />
                    <TextInput
                      labelText="Your Company Email"
                      type="email"
                      placeholder="Enter Company Email"
                      errorMessage={errors.companyEmail?.message}
                      {...register("companyEmail")}
                    />
                    <Button
                      type="submit"
                      variant="info"
                      className="w-100 border-radius-100 mt-3"
                    >
                      {uploadLoader ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        " Continue"
                      )}
                    </Button>
                    <Link
                      className="mt-4 d-block"
                      onClick={handleCloseModal}
                    >
                      Or Choose a Different Option
                    </Link>
                  </form>
                )}
                {level === 2 && (
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <label className="form-label mb-3">
                      Enter OTP sent to your email
                    </label>
                    <div className="otpResponsive">
                    <OtpInput
                      value={otp}
                      onChange={handleChange}
                      numInputs={6}
                      separator={<span style={{ width: "4px" }}></span>}
                      isInputNum={true}
                      shouldAutoFocus={true}
                      inputStyle={{
                        width: "4rem",
                        height: "4rem",
                        margin: "0 0.5rem",
                        fontSize: "1.5rem",
                        borderRadius: 4,
                        border: "1px solid #ced4da",
                      }}
                      focusStyle={{
                        border: "1px solid #CFD3DB",
                        outline: "none",
                      }}
                    />

                    </div>
                    {errors.otp && (
                      <div className="text-danger mt-2">
                        {errors.otp.message}
                      </div>
                    )}
                    <Button
                      onClick={handleOtpVerify}
                      variant="info"
                      className="w-100 border-radius-100 mt-3"
                    >
                      {uploadLoader ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Verify OTP"
                      )}
                    </Button>
                    <div className="mt-3 text-center">
                      {!canResend ? (
                        <span className="text-muted">
                          Resend OTP in {timer}s
                        </span>
                      ) : (
                        <Button
                          disabled={resendOtpLoader}
                          variant="link"
                          onClick={resendOtp}
                        >
                          Resend OTP
                        </Button>
                      )}
                    </div>
                  </div>
                )}

                {level === 3 && (
                  <form onSubmit={handleSubmit(handleEmailSubmit)}>
                    <TextInput
                      labelText="Vendor Invitation Link"
                      type="text"
                      placeholder="Enter Vendor Invitation Link"
                      required
                      value={vendorInviteLink}
                      onChange={(e) => setVendorInviteLink(e.target.value)}
                    />
                    <Button
                      type="button"
                      onClick={handleSubmitVendorLink}
                      variant="info"
                      className="w-100 border-radius-100 mt-3"
                    >
                      {uploadLoader ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        " Continue"
                      )}
                    </Button>
                    <Link
                      className="mt-4 d-block"
                      onClick={handleCloseModal}
                    >
                      Or Choose a Different Option
                    </Link>
                  </form>
                )}
              </>
            ) : modalType === "chooseOption" ? (
              <>
                <div className="upload_box" onClick={triggerFileInput}>
                  <input
                    type="file"
                    id="fileUpload"
                    ref={fileInputRef}
                    accept=".jpg,.png"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    // accept="image/*"
                  />

                  {filePreview ? (
                    <img
                      src={filePreview}
                      alt="Preview"
                      className="uploaded-image"
                      style={{
                        width: "100%",
                        maxHeight: "200px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <div style={{ cursor: "pointer", textAlign: "center" }}>
                      <Icon
                        icon="ep:upload-filled"
                        color="#0071E3"
                        fontSize={50}
                      />
                      <p className="mb-0 upLink">
                        <Link>Click here</Link> to upload or drop image here
                      </p>
                      <p className="mb-0 smallSize">
                        Support Jpg, png
                      </p>
                    </div>
                  )}
                </div>

                <Button
                  disabled={uploadLoader}
                  onClick={handleSubmitImage}
                  variant="info"
                  className="w-100 border-radius-100 mt-4"
                >
                  {uploadLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    " Continue"
                  )}
                </Button>
                <Link
                  className="mt-4 d-block"
                  onClick={handleCloseModal}
                >
                  Or Choose a Different Option
                </Link>
              </>
            ) : null}
          </div>
        }
        show={modalType !== ""}
        onClose={handleCloseModal}
        preventClose={modalType === "moda1" && level === 2} 
        // onClose={(e) => {
        //   // Only allow closing if not in OTP verification screen
        //   if (modalType === "moda1" && level === 2) {
        //     return; // Prevent closing
        //   }
        //   handleCloseModal(e);
        // }}
      />

      <CommonModal
        
        className={`modal-fade verifyModal ${fade ? "fade-out" : "fade-in"}`}
        title={""}
        para={""}
        body={
          <div className="mt-4">
            <Image src={IMAGES.Earthquake_Img} className="w-50" alt="verify" />
            <h2 className="mb-2 h2Font">It's sad to see you leave.</h2>
            <p>
              Additional verification is required to continue with this review.
            </p>
            <Button
              onClick={() => handleCloseModal1("")}
              variant="info"
              className="w-100 border-radius-100 mt-2"
            >
              Verify Now
            </Button>
            <Link
              onClick={() => {
                handleCloseModal1();
                localStorage.removeItem("step");
                localStorage.removeItem("checkedProducts");
              }}
              to={"/"}
              className="mt-4 d-block"
            >
              Back to Home
            </Link>
          </div>
        }
        show={modalType1 !== ""}
        onClose={handleCloseModal1}
      />
    </div>
  );
};

export default StepTwoComponent;
